import { render } from "./DocumentPage.vue?vue&type=template&id=538ff210&scoped=true"
import script from "./DocumentPage.vue?vue&type=script&lang=js"
export * from "./DocumentPage.vue?vue&type=script&lang=js"

import "../../assets/scss/document_page.scss?vue&type=style&index=0&id=538ff210&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538ff210"]])

export default __exports__